const table = [
    {
        prop: 'Region',
        label: 'Región',
        minWidth: 100
    },
    {
        prop: 'Depart_Code',
        label: 'Cod. Dpto.',
        minWidth: 100
    },
    {
        prop: 'Depart_Nombre',
        label: 'Departamento',
        minWidth: 150
    },
    {
        prop: 'Municipio_Code',
        label: 'Cod. Munic.',
        minWidth: 100
    },
    {
        prop: 'Municipio',
        label: 'Municipio',
        minWidth: 150
    },
    {
        prop: 'IDPunto',
        label: 'ID Punto',
        minWidth: 150
    },
    {
        prop: 'Coordenadas',
        label: 'Coordenadas',
        minWidth: 150
    },
    {
        prop: 'Cedula',
        label: 'Cédula',
        minWidth: 150
    },
    {
        prop: 'Nombres',
        label: 'Cliente',
        minWidth: 150
    },
    {
        prop: 'Estado',
        label: 'Estado',
        minWidth: 150
    },
    {
        prop: 'FechaEvent',
        label: 'Fecha',
        minWidth: 150
    }
]

const table_plus = [
    {
        prop: "Operador",
        label: "Operador", 
    },
    {
        prop: "Estrato",
        label: "Estrato", 
    },
    {
        prop: "Dificultades_Acceso",
        label: "Dificulta Acceso", 
    },
    {
        prop: "FechaUpdate",
        label: "Fecha Actualización", 
    },
    {
        prop: "Barrio",
        label: "Barrio", 
    },
    {
        prop: "Direccion",
        label: "Dirección", 
    },
    {
        prop: "Telefono",
        label: "Telefono", 
    },
    {
        prop: "Celular",
        label: "Celular", 
    },
    {
        prop: "CorreoE",
        label: "Correo", 
    },
    {
        prop: "VIP",
        label: "VIP", 
    },
    {
        prop: "ProyectoCodeVIP",
        label: "Código VIP", 
    },
    {
        prop: "ProyectoNombreVIP",
        label: "Nombre VIP", 
    },
    {
        prop:"VelocidadContratada",
        label:"VelocidadContratada",
    },
    {
        prop:"Meta",
        label:"Meta",
    },
    {
        prop:"FecMeta",
        label:"FechaMeta",
    },
    {
        prop:"DiasPendienteMeta",
        label:"DiasPendienteMeta",
    },
    {
        prop:"SolUM",
        label:"SolUM",
    },
    {
        prop:"OperadorPrestante",
        label:"OperadorPrestante",
    },
    {
        prop: "IP",
        label: "IP", 
    },
    {
        prop:"OLT",
        label:"OLT",
    },
    {
        prop:"PuertoOLT",
        label:"PuertoOLT",
    },
    {
        prop: "Mac",
        label: "MAC", 
    },
    {
        prop:"PortONU",
        label:"PortONU",
    },
    {
        prop:"Nodo",
        label:"Nodo",
    },
    {
        prop:"Armario",
        label:"Armario",
    },
    {
        prop:"RedPrimaria",
        label:"RedPrimaria",
    },
    {
        prop:"RedSecundaria",
        label:"RedSecundaria",
    },
    {
        prop:"Ndo",
        label:"Ndo",
    },
    {
        prop:"Amplificador",
        label:"Amplificador",
    },
    {
        prop:"TapBoca",
        label:"TapBoca",
    },
    {
        prop:"MacCpe",
        label:"MacCpe",
    },
    {
        prop:"FecInstalado",
        label:"FechaInstalado",
    },
    {
        prop:"FecActivo",
        label:"FechaActivo",
    },
    {
        prop:"FecDesinstalado",
        label:"FecDesinstalado",
    },
    {
        prop:"FechaIniOp",
        label:"FecIniOp",
    },
    {
        prop:"FechaTraslado",
        label:"FecTraslado",
    },
    {
        prop:"FechaInactivo",
        label:"FecInactivo",
    },
    {
        prop: "velBajada",
        label: "Vel. Bajada", 
    },
    {
        prop: "velSubida",
        label: "Vel. Subida", 
    },
    {
        prop:"Sisben4",
        label:"Sisben4",
    },
    {
        prop: "Etnia",
        label: "Etnia", 
    },
    {
        prop: "Genero",
        label: "Género", 
    },
    {
        prop: "OrientSexual",
        label: "Orientación Sexual", 
    },
    {
        prop: "Sexo",
        label: "Sexo", 
    },
    {
        prop: "NivelEducativo",
        label: "Nivel Educativo", 
    },
    {
        prop: "Discapacidad",
        label: "Discapacidad", 
    },
    {
        prop: "BeneficiarioLey1699",
        label: "BeneficiarioLey1699", 
    },
    
    
]

export default [table, table_plus]